import AssetComparisonStep from './AssetComparisonStep'

export default AssetComparisonStep
